export const CONTEXT_PATH = "ct";
export const SOCKET_URL= "http://localhost:8080/ws";
export const BASE_URL= "https://app.chatelaintours.com/api/public/";
export const IMAGE_URL= "https://app.chatelaintours.com/api/public";
//  export const IMAGE_URL= "http://127.0.0.1:8000";
// export const BASE_URL= "http://127.0.0.1:8000/";
export const BASE_URL_LOCAL= "http://127.0.0.1:8000";
export const SOCKET_HOST= "https://app.chatelaintours.com";
export const SOCKET_AUTH= "https://app.chatelaintours.com/api/public/api/broadcasting/auth";
